export default "__VITE_ASSET__29bbbe70__"